import { Component } from '@angular/core';
import { ProgressBarComponent } from '../../../../../shared/progress/components/progress-bar/progress-bar.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-error-layout',
    templateUrl: './error-layout.component.html',
    styleUrls: ['./error-layout.component.scss'],
    imports: [ProgressBarComponent, RouterOutlet]
})
export class ErrorLayoutComponent {

}
